module.exports = __webpack_public_path__ + "assets/media/1_livechatjourney.2c147633.svg";